export type ScannerMode = "usb" | "camera";

export function isProbablyMobile(): boolean {
  const hasTouch =
    typeof window !== "undefined" &&
    ("ontouchstart" in window || (navigator.maxTouchPoints ?? 0) > 0);

  const ua = typeof navigator !== "undefined" ? navigator.userAgent : "";
  const uaMobile = /Android|iPhone|iPad|iPod|Mobile/i.test(ua);

  // Hybrid: treat touch devices as mobile even on desktop UA.
  return hasTouch || uaMobile;
}

export function getDefaultScannerMode(): ScannerMode {
  return isProbablyMobile() ? "camera" : "usb";
}

